module.exports = __webpack_public_path__ + "img/icon-login-black.61c12c3a.svg";